import { render } from "./CollectionsTable.vue?vue&type=template&id=4fd19685"
import script from "./CollectionsTable.vue?vue&type=script&lang=js"
export * from "./CollectionsTable.vue?vue&type=script&lang=js"
script.render = render

export default script